/* eslint-disable */
// noinspection JSUnusedLocalSymbols

import { deleteUser, signOut } from 'aws-amplify/auth';
import log from 'src/utils/logger';
import { useContext } from 'react';
import AuthContext from 'src/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import {
  useDeleteAttachment,
  useQueryParams,
  useResetAllStoredData,
} from 'src/hooks';
import { AppRoutes } from 'src/types';
import { isEnterprise } from 'src/utils';
import { REFERRAL_ID } from 'src/constants';
import Cookies from 'js-cookie';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { env } from 'src/env';

const SUPER_NINJA_RETURN_URL_COOKIE_NAME = '_superNinjaReturnUrl';

export interface Props {
  logout: () => Promise<void>;
  logoutWithRedirectToSignUp: () => void;
  deleteCognitoUser: () => Promise<void>;
}

export const useLogout = (): Props => {
  const { setAuthLoading } = useContext(AuthContext);
  const navigate = useNavigate();
  const { removeAllSearchParams } = useQueryParams();
  const { onDeleteAllAttachments } = useDeleteAttachment();

  const { onResetAllStoredData } = useResetAllStoredData();

  const enableHandlingOfBusinessLogicInSN =
    useFeatureFlagEnabled('handleBusinessInSN');

  const deleteCognitoUser = async () => {
    try {
      await onResetAllStoredData();
      removeAllSearchParams();
      await deleteUser();
    } catch (error) {
      log.error(error);
    }
  };

  const logout = async () => {
    try {
      setAuthLoading(true);

      await onDeleteAllAttachments();
      await onResetAllStoredData();
      if (!!localStorage.getItem(REFERRAL_ID)) {
        localStorage.removeItem(REFERRAL_ID);
      }
      await signOut();
      if (isEnterprise) {
        // TODO: check why we are getting forever loading for enterprise on logout
        window.location.reload();
      } else {
        const _returnUrl = Cookies.get(SUPER_NINJA_RETURN_URL_COOKIE_NAME);
        if (_returnUrl && !enableHandlingOfBusinessLogicInSN) {
          Cookies.remove(SUPER_NINJA_RETURN_URL_COOKIE_NAME, {
            domain: window.location.hostname,
          });
          window.location.href = _returnUrl;
        } else {
          if (enableHandlingOfBusinessLogicInSN) {
            window.location.href = env.REACT_APP_SUPER_NINJA_URL;
          } else {
            navigate(AppRoutes.HOME);
          }
        }
      }
    } catch (error) {
      log.error(error);
      setAuthLoading(false);
    }
  };

  const logoutWithRedirectToSignUp = async () => {
    await logout();
    navigate(AppRoutes.SIGN_UP);
  };

  return {
    logout,
    deleteCognitoUser,
    logoutWithRedirectToSignUp,
  };
};
